export default {
  roles: null,
  selectedRole: undefined,
  userInfo: {},
};
